import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './App.css';
import App from './App.tsx';
import * as Sentry from '@sentry/react';

window.shouldInitFlow = false;

const environment = import.meta.env.MODE;
const isProduction = environment == "production";

isProduction && Sentry.init({
  dsn: "https://ff375ffec8d1872e8234d09f9f2c99aa@o4510281287532544.ingest.de.sentry.io/4510281770664017",
  environment,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    "portal.musio",
    "localhost",
    import.meta.env.VITE_API_URL,
  ],
  sendDefaultPii: true,
  // TODO: change this when in prod
  replaysSessionSampleRate: isProduction ? 0.1 : 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in isProudction.
  replaysOnErrorSampleRate: isProduction ? 0.1 : 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
